import type { JurisdictionProfile, Strings } from '../types';
import type { AudioManager } from '../audio/audio';
import type { Game } from '../engine/game';
import { t } from '../util/format';
import { createModal, el, type Modal } from './modal';

/** Settings modal: sound on/off, quick spin (when the jurisdiction allows it). */
export class Settings {
  private readonly root: HTMLElement;
  private strings: Strings;
  private readonly jurisdiction: JurisdictionProfile;
  private readonly audio: AudioManager;
  private readonly game: Game;
  private modal: Modal | null = null;

  constructor(o: { root: HTMLElement; strings: Strings; jurisdiction: JurisdictionProfile; audio: AudioManager; game: Game }) {
    this.root = o.root;
    this.strings = o.strings;
    this.jurisdiction = o.jurisdiction;
    this.audio = o.audio;
    this.game = o.game;
  }

  get isOpen(): boolean {
    return !!this.modal?.open;
  }

  setStrings(strings: Strings): void {
    this.strings = strings;
  }

  private toggle(label: string, checked: boolean, disabled: boolean, onChange: (on: boolean) => void): HTMLElement {
    const row = el('label', 'slot-toggle');
    const input = el('input');
    input.type = 'checkbox';
    input.checked = checked;
    input.disabled = disabled;
    input.addEventListener('change', () => onChange(input.checked));
    row.append(el('span', undefined, label), input);
    return row;
  }

  open(onClose?: () => void): void {
    this.close();
    const S = this.strings;
    this.modal = createModal(this.root, { title: t(S, 'settings'), size: 'narrow', closeLabel: t(S, 'close'), onClose });
    const body = this.modal.body;
    body.appendChild(this.toggle(t(S, 'sound'), this.audio.enabled, false, (on) => this.audio.setEnabled(on)));
    if (this.jurisdiction.allowTurbo) {
      body.appendChild(this.toggle(t(S, 'quickSpin'), this.game.snapshot.quickSpin, false, (on) => this.game.setQuickSpin(on)));
    }
  }

  close(): void {
    this.modal?.close();
    this.modal = null;
  }
}
